import * as React from "react";
import Attribute from "../../presentations/Attribute";

const AttributeContainer = (props: any) => {

  const {data} = props;

  return (
    <div>
      <Attribute data={data}></Attribute>
    </div>
  );
};

export default AttributeContainer;
